import { flatten, uniq } from 'lodash';

export default function getSbatGroupsSuperBatchIds(sbatGroups) {
  return uniq(
    flatten(
      Object.values(sbatGroups).map((sbatGroup) =>
        sbatGroup.super_batch_academy_topics.map((sbat) => sbat.super_batch.id)
      )
    )
  );
}
